import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import Fa from 'react-fontawesome';
import {
  indexOf, delay, each, map,
} from 'lodash';
import SearchField from '../../../../components/search-field';

function NameRenderer(props) {
  const { data, value } = props;
  if (!data) {
    return null;
  }
  const { description } = data;
  const hasDescription = description !== null && description !== undefined && description.trim().length > 0;
  if (!hasDescription) {
    return (<span>{value}</span>);
  }
  const tooltip = (
    <Tooltip id={`${data._id}_tooltip`}>{description}</Tooltip>
  );
  return (
    <span>{value} <OverlayTrigger placement="right" overlay={tooltip}><Fa className="text-active" name="info-circle" /></OverlayTrigger></span>
  );
}
NameRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string,
    description: PropTypes.string,
  }),
};
NameRenderer.defaultProps = {
  value: null,
  data: null,
};

class ProductTable extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.onFirstDataRendered();
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { width } = this.props;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        const { selectedProductIds } = this.props;
        this.gridApi.forEachNode((node) => {
          const nodeData = node.data;
          if (nodeData) {
            const selected = indexOf(selectedProductIds, nodeData.id) >= 0;
            node.setSelected(selected);
          } else {
            node.setSelected(false);
          }
        });

        this.gridApi.hideOverlay();
      }, 500);
    }
  }

  onSelectionChanged() {
    if (!this.props.disabled && this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      this.props.onSelectProducts(selectedRows);
    }
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  render() {
    const {
      products, selectedProductIds,
      isActive,
    } = this.props;

    if (!isActive) {
      return null;
    }
    const validProducts = products;
    let found = false;
    validProducts.map((product) => {
      if (indexOf(selectedProductIds, product.id) >= 0) {
        found = true;
      }
      return product;
    });

    const rowHeight = 43;
    const tableHeight = Math.min(202, (rowHeight * validProducts.length) + rowHeight + 2);
    const columnDefs = [
      {
        headerName: 'TruVoice Product',
        colId: 'NAME',
        field: 'name',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        cellRenderer: NameRenderer,
      },
    ];
    return (
      <div ref={(el) => { this.container = el; }}>
        {!found && <div className="alert alert-danger">Please select at least one product</div>}
        {validProducts.length >= 5 &&
          <nav className="navbar navbar-default navbar-controls">
            <div className="navbar-form navbar-left">
              <SearchField onSearch={this.handleSearch} />
            </div>
          </nav>
        }
        {validProducts.length > 0 &&
          <div className="ag-theme-alpine" style={{ width: '100%', height: tableHeight }}>
            <AgGridReact
              reactNext
              enableColResize
              enableSorting
              animateRows
              suppressColumnVirtualisation
              columnDefs={columnDefs}
              getRowId={({ data }) => data.id}
              onGridReady={this.onGridReady}
              rowData={validProducts}
              rowSelection="multiple"
              onSelectionChanged={this.onSelectionChanged}
              rowHeight={rowHeight}
            />
          </div>
        }
      </div>
    );
  }
}

ProductTable.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedProductIds: PropTypes.arrayOf(PropTypes.string),
  onToggleProduct: PropTypes.func,
  onSelectProducts: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  isActive: PropTypes.bool,
};
ProductTable.defaultProps = {
  onToggleProduct: () => {},
  selectedProductIds: [],
  onSelectProducts: () => {},
  isActive: false,
};

export default ProductTable;
